import axios from "axios"
const API_URL = `${process.env.REACT_APP_APP_URL}/api/tickets`

const create = async (ticketData, token) => {
    const config = {
        headers:{
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.post(API_URL, ticketData, config)

    return response.data
}

const getAll = async (token) => {
    const config = {
        headers:{
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.get(API_URL, config)

    return response.data
}

const get = async (ticketId, token) => {
    const config = {
        headers:{
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.get(API_URL + `/${ticketId}`, config)

    return response.data
}

const close = async (ticketId, token) => {
    const config = {
        headers:{
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.put(API_URL + `/${ticketId}`, {status: "closed"}, config)

    return response.data
}

const ticketService = {
    create,
    getAll,
    get,
    close
}

export default ticketService